import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Useletter from '../Useletter';
import Foter from '../Foter';
function Sixpic() {
  return (
    <div>
             <Container>

        
<Row>
<Col >
<div className="par">
<div id="shop"><b>Shopping Now</b></div>

  <div id="line"></div>
  <div id="cate">CATEGORY</div>
  <div id="line"></div>
  <div id="cate">STYLING</div>
  <div id="line"></div>
  <div id="cate">COLOR FAMILY</div>
  <div id="line"></div>
  <div id="cate">SEASON</div>
  <div id="line"></div>
  <div id="cate">PRODUCT CATEGORY</div> 
  <div id="line"></div>
  <div id="cate">SIZE</div>
   <div id="line"></div>
  <div id="cate">FABRIC</div>
</div>
</Col>

<Col>
  <div className="box-cont">
  <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/4/6/46496_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
     alt=''style={{height:'250px', width:'100%' }} /> </div>
<br /><br />
<div className='hiding'><p>Black Cambric Printed Unstitched 3PC|-25<br />3223</p></div>
   <div className="style" style={{display:'flex'}}>
<div id="off"style={{height:'25px',width:'70px',backgroundColor:'#DF0024',color:'#FFFFFF'}}> 15% OFF</div>
     <div style={{color:'#DF0024'}}> <b>PKR 4,146.50</b> </div>
      <div style={{textDecoration:'line-through',marginLeft:'7px',}}> PKR4,840</div>
     </div><br /><button className='bt' > ADD TO BAG</button>
</div>

  </Col>
  <Col> <div className="box-cont">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/4/7/47350_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
alt=''style={{height:'250px', width:'100%',

}} /></div>
<br /><br />
<div className='hiding'><p>Black Cambric Printed Unstitched 3PC|-25<br />3223</p></div>
   <div className="style" style={{display:'flex'}}>
<div id="off"style={{height:'25px',width:'70px',backgroundColor:'#DF0024',color:'#FFFFFF'}}> 15% OFF</div>
     <div style={{color:'#DF0024'}}> <b>PKR 4,146.50</b> </div>
      <div style={{textDecoration:'line-through',marginLeft:'7px',}}> PKR4,840</div>
     </div><br /><button className='bt' > ADD TO BAG</button>
</div></Col>
<Col> <div className="box-cont">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/3/3/33102_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
alt=''style={{height:'250px', width:'100%',

}} /></div>
<br /><br />
<div className='hiding'><p>Black Cambric Printed Unstitched 3PC|-25<br />3223</p></div>
   <div className="style" style={{display:'flex'}}>
<div id="off"style={{height:'25px',width:'70px',backgroundColor:'#DF0024',color:'#FFFFFF'}}> 15% OFF</div>
     <div style={{color:'#DF0024'}}> <b>PKR 4,146.50</b> </div>
      <div style={{textDecoration:'line-through',marginLeft:'7px',}}> PKR4,840</div>
     </div><br /><button className='bt' > ADD TO BAG</button>
</div></Col> 


  
</Row>
</Container>
<Container>

        
<Row>
<Col >

</Col>

<Col>
  <div className="box-cont">
  <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/j/j/jjk-sp-inr-a-45512_1__1.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
     alt=''style={{height:'250px', width:'100%' }} /> </div>
<br /><br />
<div className='hiding'><p>Black Cambric Printed Unstitched 3PC|-25<br />3223</p></div>
   <div className="style" style={{display:'flex'}}>
<div id="off"style={{height:'25px',width:'70px',backgroundColor:'#DF0024',color:'#FFFFFF'}}> 15% OFF</div>
     <div style={{color:'#DF0024'}}> <b>PKR 4,146.50</b> </div>
      <div style={{textDecoration:'line-through',marginLeft:'7px',}}> PKR4,840</div>
     </div><br /><button className='bt' > ADD TO BAG</button>
</div>

  </Col>
  <Col> <div className="box-cont">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/j/j/jjk-33142_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
alt=''style={{height:'250px', width:'100%',

}} /></div>
<br /><br />
<div className='hiding'><p>Black Cambric Printed Unstitched 3PC|-25<br />3223</p></div>
   <div className="style" style={{display:'flex'}}>
<div id="off"style={{height:'25px',width:'70px',backgroundColor:'#DF0024',color:'#FFFFFF'}}> 15% OFF</div>
     <div style={{color:'#DF0024'}}> <b>PKR 4,146.50</b> </div>
      <div style={{textDecoration:'line-through',marginLeft:'7px',}}> PKR4,840</div>
     </div><br /><button className='bt' > ADD TO BAG</button>
</div></Col>
<Col> <div className="box-cont">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/4/7/47316_1__1.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
alt=''style={{height:'250px', width:'100%',

}} /></div>
<br /><br />
<div className='hiding'><p>Black Cambric Printed Unstitched 3PC|-25<br />3223</p></div>
   <div className="style" style={{display:'flex'}}>
<div id="off"style={{height:'25px',width:'70px',backgroundColor:'#DF0024',color:'#FFFFFF'}}> 15% OFF</div>
     <div style={{color:'#DF0024'}}> <b>PKR 4,146.50</b> </div>
      <div style={{textDecoration:'line-through',marginLeft:'7px',}}> PKR4,840</div>
     </div><br /><button className='bt' > ADD TO BAG</button>
</div></Col> 


  
</Row>
</Container>
<Container>

        
<Row>
<Col >
</Col>

<Col>
  <div className="box-cont">
  <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/4/6/46496_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
     alt=''style={{height:'250px', width:'100%' }} /> </div>
<br /><br />
<div className='hiding'><p>Black Cambric Printed Unstitched 3PC|-25<br />3223</p></div>
   <div className="style" style={{display:'flex'}}>
<div id="off"style={{height:'25px',width:'70px',backgroundColor:'#DF0024',color:'#FFFFFF'}}> 15% OFF</div>
     <div style={{color:'#DF0024'}}> <b>PKR 4,146.50</b> </div>
      <div style={{textDecoration:'line-through',marginLeft:'7px',}}> PKR4,840</div>
     </div><br /><button className='bt' > ADD TO BAG</button>
</div>

  </Col>
  <Col> <div className="box-cont">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/4/7/47350_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
alt=''style={{height:'250px', width:'100%',

}} /></div>
<br /><br />
<div className='hiding'><p>Black Cambric Printed Unstitched 3PC|-25<br />3223</p></div>
   <div className="style" style={{display:'flex'}}>
<div id="off"style={{height:'25px',width:'70px',backgroundColor:'#DF0024',color:'#FFFFFF'}}> 15% OFF</div>
     <div style={{color:'#DF0024'}}> <b>PKR 4,146.50</b> </div>
      <div style={{textDecoration:'line-through',marginLeft:'7px',}}> PKR4,840</div>
     </div><br /><button className='bt' > ADD TO BAG</button>
</div></Col>
<Col> <div className="box-cont">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/3/3/33102_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
alt=''style={{height:'250px', width:'100%',

}} /></div>
<br /><br />
<div className='hiding'><p>Black Cambric Printed Unstitched 3PC|-25<br />3223</p></div>
   <div className="style" style={{display:'flex'}}>
<div id="off"style={{height:'25px',width:'70px',backgroundColor:'#DF0024',color:'#FFFFFF'}}> 15% OFF</div>
     <div style={{color:'#DF0024'}}> <b>PKR 4,146.50</b> </div>
      <div style={{textDecoration:'line-through',marginLeft:'7px',}}> PKR4,840</div>
     </div><br /><button className='bt' > ADD TO BAG</button>
</div></Col> 


  
</Row>
</Container>
<Container>

        
<Row>
<Col >

</Col>

<Col>
  <div className="box-cont">
  <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/j/j/jjk-sp-inr-a-45512_1__1.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
     alt=''style={{height:'250px', width:'100%' }} /> </div>
<br /><br />
<div className='hiding'><p>Black Cambric Printed Unstitched 3PC|-25<br />3223</p></div>
   <div className="style" style={{display:'flex'}}>
<div id="off"style={{height:'25px',width:'70px',backgroundColor:'#DF0024',color:'#FFFFFF'}}> 15% OFF</div>
     <div style={{color:'#DF0024'}}> <b>PKR 4,146.50</b> </div>
      <div style={{textDecoration:'line-through',marginLeft:'7px',}}> PKR4,840</div>
     </div><br /><button className='bt' > ADD TO BAG</button>
</div>

  </Col>
  <Col> <div className="box-cont">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/j/j/jjk-33142_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
alt=''style={{height:'250px', width:'100%',

}} /></div>
<br /><br />
<div className='hiding'><p>Black Cambric Printed Unstitched 3PC|-25<br />3223</p></div>
   <div className="style" style={{display:'flex'}}>
<div id="off"style={{height:'25px',width:'70px',backgroundColor:'#DF0024',color:'#FFFFFF'}}> 15% OFF</div>
     <div style={{color:'#DF0024'}}> <b>PKR 4,146.50</b> </div>
      <div style={{textDecoration:'line-through',marginLeft:'7px',}}> PKR4,840</div>
     </div><br /><button className='bt' > ADD TO BAG</button>
</div></Col>
<Col> <div className="box-cont">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/4/7/47316_1__1.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
alt=''style={{height:'250px', width:'100%',

}} /></div>
<br /><br />
<div className='hiding'><p>Black Cambric Printed Unstitched 3PC|-25<br />3223</p></div>
   <div className="style" style={{display:'flex'}}>
<div id="off"style={{height:'25px',width:'70px',backgroundColor:'#DF0024',color:'#FFFFFF'}}> 15% OFF</div>
     <div style={{color:'#DF0024'}}> <b>PKR 4,146.50</b> </div>
      <div style={{textDecoration:'line-through',marginLeft:'7px',}}> PKR4,840</div>
     </div><br /><button className='bt' > ADD TO BAG</button>
</div></Col> 


  
</Row>
</Container>
<Useletter/>
<Foter/>

    </div>
  )
}

export default Sixpic
